import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-auth-error',
  templateUrl: './auth-error.component.html',
  styleUrls: ['./auth-error.component.sass'],
  standalone: false
})
export class AuthErrorComponent {
  constructor(public auth: AuthService) {}

  login(): void {
    this.redirectToOrigin();
  }

  private redirectToOrigin(): void {
    window.location.replace(window.location.origin);
  }
}
